/* Anthea Manari: inline variant selection + direct add to bag on product cards */
(function () {
  if (customElements.get('am-card-buy')) return;

  class AmCardBuy extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      } catch (e) {
        this.variants = [];
      }
      this.card = this.closest('product-card');
      this.addEventListener('change', () => this.update(false));
      this.update(true);
    }

    selected() {
      return Array.from(this.querySelectorAll('.am-opt')).map((f) => {
        const s = f.querySelector('select');
        if (s) return s.value || null;
        const r = f.querySelector('input:checked');
        return r ? r.value : null;
      });
    }

    update(initial) {
      const btn = this.querySelector('[data-add]');
      const idInput = this.querySelector('[data-id]');
      const price = this.querySelector('[data-price]');
      const opts = this.querySelectorAll('.am-opt');
      if (!opts.length) return;

      const sel = this.selected();
      const colorSet = this.querySelector('.am-opt[data-color]');
      if (colorSet) {
        const label = colorSet.querySelector('[data-color-label]');
        const checked = colorSet.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      }

      const complete = sel.every((v) => v !== null && v !== '');
      const match = complete ? this.variants.find((v) => v.options.every((o, i) => o === sel[i])) : null;

      if (!initial) {
        const imageVariant = match || this.variants.find((v) => v.options.every((o, i) => sel[i] == null || o === sel[i]));
        if (imageVariant && imageVariant.featured_image) this.swapImage(imageVariant.featured_image.src);
      }

      if (match) {
        idInput.value = match.id;
        price.textContent = this.money(match.price);
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
      } else {
        btn.disabled = true;
        btn.textContent = btn.dataset.labelChoose;
      }
    }

    swapImage(src) {
      if (!this.card) return;
      const img = this.card.querySelector('.product-card__image--primary');
      if (!img) return;
      const url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
      img.removeAttribute('srcset');
      img.src = url;
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
          minimumFractionDigits: cents % 100 ? 2 : 0,
          maximumFractionDigits: 2,
        }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0);
      }
    }
  }

  customElements.define('am-card-buy', AmCardBuy);
})();
